import { useBackend } from "../../services";

export const useGetAIAlbumInsights = () => {
  const { get } = useBackend();
  return async (albumId: string, force: boolean) => {
    let url = `ai/insights/album/${albumId}`;
    if (force) url = url.concat("?force=1");
    return await get(url);
  };
};
